<div *ngIf="selectedEventTicket$ | async as eventTicket" class="gb-event-ticket-mismatch-dialog">
  <mat-toolbar role="toolbar" class="gb-dialog-header">
    <h2 translate="EVENT_TICKET.ACCEPT_TICKET.MISMATCH.HEADER" mat-dialog-title></h2>
    <button mat-icon-button mat-dialog-close>
      <mat-icon>close</mat-icon>
    </button>
  </mat-toolbar>

  <mat-dialog-content>
    <div class="flex-col px-gap-14">
      <gb-callout color="accent">
        <div class="flex-row flex-align-center px-gap-14">
          <div class="flex-col">
            <mat-icon class="check-circle" color="accent">warning</mat-icon>
          </div>
          <span translate="EVENT_TICKET.ACCEPT_TICKET.MISMATCH.DESCRIPTION"></span>
        </div>
      </gb-callout>

      <div>
        <p
          [innerHTML]="
            'EVENT_TICKET.ACCEPT_TICKET.MISMATCH.ASSIGN_TO_ME_INFO'
              | translate
                : {
                    ticketPackageName: eventTicket.ticket_package.name,
                    seatNumber:
                      eventTicket.ticket_package.tickets_included > 1
                        ? '- ' + (eventTicket.seat_number | gbEventTicketSeatLabel)
                        : ''
                  }
          "
        ></p>

        <p
          [innerHTML]="
            'EVENT_TICKET.ACCEPT_TICKET.MISMATCH.ACCEPT_ON_BEHALF_INFO'
              | translate: { email: eventTicket.profile?.email }
          "
        ></p>
      </div>
    </div>
  </mat-dialog-content>

  <mat-dialog-actions>
    <div class="flex-col flex-grow px-gap-10">
      <div class="flex-row">
        <button
          mat-raised-button
          color="primary"
          type="button"
          (click)="onAssignToMe()"
          translate="EVENT_TICKET.ACCEPT_TICKET.MISMATCH.ASSIGN_TO_ME_BUTTON"
          [mat-dialog-close]="true"
        ></button>
      </div>

      <div class="flex-row flex-justify-center px-gap-5">
        <span translate="EVENT_TICKET.ACCEPT_TICKET.MISMATCH.OR"> </span>
        <span
          translate="EVENT_TICKET.ACCEPT_TICKET.MISMATCH.ACCEPT_ON_BEHALF_LINK"
          [translateParams]="{ email: eventTicket.profile?.email }"
          (click)="onAcceptOnBehalf()"
          [mat-dialog-close]="true"
          class="primary-link"
        >
        </span>
      </div>
    </div>
  </mat-dialog-actions>
</div>
